module.exports = "/_next/static/images/1c3488c10e27fbbc781ce0a985226247-add-person-avatar-4x.png.webp";